import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AlertGraphModalPage } from './alert-graph-modal.page';

const routes: Routes = [
  {
    path: '',
    component: AlertGraphModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AlertGraphModalPageRoutingModule {}
